import GameLibraryPageContent from '../components/GameLibrary/GameLibraryPageContent';

const GameLibraryPage = () => {
  return <GameLibraryPageContent />;
};

export default GameLibraryPage;
